import { createPinia } from 'pinia'
import { ViteSSG } from 'vite-ssg'

import App from './App.vue'
import { routes } from './router'
import { useAuthStore } from './stores/auth'
import { useLoginModalStore } from './stores/loginModal'
import { AUTH_EXPIRED_EVENT, AUTH_EXPIRED_STORAGE_KEY } from './lib/apiClient'
import GlobalLoginModal from './components/GlobalLoginModal.vue'
import GlobalPaymentModal from './components/GlobalPaymentModal.vue'

import './styles/tokens.css'
import './style.css'
import './styles/seoStyle.css'
import './styles/taskStatus.css'

export const createApp = ViteSSG(App, { routes, base: import.meta.env.BASE_URL }, ({ app, router }) => {
  const pinia = createPinia()
  app.use(pinia)
  app.component('GlobalLoginModal', GlobalLoginModal)
  app.component('GlobalPaymentModal', GlobalPaymentModal)
  if (typeof window !== 'undefined' && !import.meta.env.SSR) {
    const buildTarget = String((import.meta.env as any)?.VITE_BUILD_TARGET || '').trim()
    const isWorkbenchOnly = buildTarget === 'workbench'
    try {
      router.beforeEach((to) => {
        const p = String(to.path || '')
        if (!p) return
        if (p.includes('.')) return
        if (isWorkbenchOnly) {
          if (p !== '/' && !p.endsWith('/')) return { path: `${p}/`, query: to.query, hash: to.hash, replace: true }
          return
        }
        if (p.startsWith('/ai-workbench') && !p.endsWith('/')) return { path: `${p}/`, query: to.query, hash: to.hash, replace: true }
      })
    } catch {}
    const auth = useAuthStore(pinia)
    const loginModal = useLoginModalStore(pinia)
    try {
      window.addEventListener(AUTH_EXPIRED_EVENT, (() => {
        try {
          auth.clearToken()
        } catch {}
        let nextPath = `${window.location.pathname || '/'}${window.location.search || ''}${window.location.hash || ''}`
        try {
          const raw = window.localStorage.getItem(AUTH_EXPIRED_STORAGE_KEY) || ''
          const parsed = raw ? JSON.parse(raw) : null
          const p = String(parsed?.path || '').trim()
          if (p) nextPath = p
        } catch {}
        loginModal.show({ tab: 'sms', nextPath, cancelPath: nextPath })
      }) as any)
    } catch {}
    ;(async () => {
      try {
        auth.syncFromStorage()
        await auth.tryRestoreLoginState()
      } catch {}
      try {
        if (auth.isLoggedIn && !auth.me) await auth.fetchMe()
      } catch {}
    })()
  }
})
